
document.addEventListener("DOMContentLoaded", function () {
  const cartAction = document.getElementById("cart-action").textContent.trim();
  let product;
  const colorMap = {};

  document.querySelectorAll("#color-data .color-item").forEach((item) => {
    colorMap[item.getAttribute("data-name")] = item.getAttribute("data-value");
  });

    function formatPrice(priceInCents) {
      const price = priceInCents / 100;
      const activeCurrency = window?.Shopify?.currency?.active || 'USD';

      let formatted = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: activeCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price);

      if (activeCurrency.toUpperCase() === 'INR') {
        formatted = formatted.replace('₹', '').trim();
        return 'Rs. ' + formatted;
      }
      return formatted;
    }

  document.addEventListener("click", function (e) {
    const openOffcanvas = document.querySelector(
        "#quick-view-offcanvas.show"
      );
      if (openOffcanvas && openOffcanvas.contains(e.target)) {
        return; 
      }
    const quickViewBtn = e.target.closest(".quick-view");
    if (quickViewBtn) {
      e.preventDefault();
      const productHandle = quickViewBtn.getAttribute("data-product-handle");
      const offerEndDate = quickViewBtn.getAttribute("data-offer-end");
  
      const toggleType = quickViewBtn.getAttribute("data-bs-toggle");

      let quickViewInstance;
      let quickViewContainer;

      if (toggleType === "modal") {
        quickViewContainer = document.getElementById("quick-view");
        quickViewInstance = new bootstrap.Modal(quickViewContainer);
      } else {
        quickViewContainer = document.getElementById("quick-view-offcanvas");
        quickViewInstance = new bootstrap.Offcanvas(quickViewContainer);
      }

      quickViewInstance.show();

      // Loader handling (IMPORTANT)
      const loader =
        toggleType === "modal"
          ? quickViewContainer.querySelector("#modalQuickViewLoader")
          : quickViewContainer.querySelector("#offcanvasQuickViewLoader");

      const content =
        toggleType === "modal"
          ? quickViewContainer.querySelector("#modalQuickViewContent")
          : quickViewContainer.querySelector("#offcanvasQuickViewContent");

      loader.classList.remove("d-none");
      content.classList.add("d-none");

      if (productHandle) {
        $.getJSON(`/products/${productHandle}.js`, function (data) {
          product = data;

          let optionsHtml = "";
          let variantsSelectHtml = `<select id="hidden-variants" style="display:none;">`;

          const hasRealVariants = product.variants.length > 1 && product.variants[0].title !== "Default Title";
          if (hasRealVariants) {
            product.options.forEach((option, index) => {
              const uniqueValues = [
                ...new Set(product.variants.map((v) => v.options[index])),
              ];

              if (uniqueValues.length > 0) {
                const defaultVariant = product.variants.find(v => v.available) || product.variants[0];
                const activeValue = defaultVariant.options[index] || uniqueValues[0];

                optionsHtml += `
                  <div class="variant-option" data-index="${index}">
                    <label class="variant-label">
                      ${option.name}: <span class="active-value" id="active-value-${index}">${activeValue}</span>
                    </label>
                `;

                if (option.name.toLowerCase().includes("color")) {
                  optionsHtml += `<div class="variant-swatches" data-index="${index}">`;
                  uniqueValues.forEach((value) => {
                    const matchingVariant = product.variants.find((v) => v.options[index] === value);
                    const isValueAvailable = product.variants.some(
                      (v) => v.options[index] === value && v.available
                    );
                    const isActive = value === activeValue ? "active" : "";
                    const soldOutClass = isValueAvailable ? "" : "disable";
                    optionsHtml += `
                      <span class="swatch variant-square ${isActive} ${soldOutClass}" 
                        data-index="${index}" 
                        data-value="${value}" 
                        data-bs-toggle="tooltip" 
                        data-bs-placement="top" 
                        data-variant-id="${matchingVariant.id}" 
                        data-image-src="${
                          matchingVariant.featured_image ? matchingVariant.featured_image.src : product.images[0].src
                        }"
                        style="background:${colorMap[value] || "#fff"};" 
                        title="${value}"
                        data-bs-title="${value}">
                      </span>`;
                  });
                  optionsHtml += `</div>`;
                } else {
                  optionsHtml += `<div class="variant-buttons" data-index="${index}">`;
                  uniqueValues.forEach((value) => {
                    const matchingVariant = product.variants.find((v) => v.options[index] === value);
                    const isValueAvailable = product.variants.some(
                      (v) => v.options[index] === value && v.available
                    );
                    const isActive = value === activeValue ? "active" : "";
                    const soldOutClass = isValueAvailable ? "" : "disable";
                    optionsHtml += `
                      <button type="button" 
                        class="variant-btn variant-square ${isActive} ${soldOutClass}" 
                        data-index="${index}" 
                        data-value="${value}" 
                        data-variant-id="${matchingVariant.id}"
                        data-image-src="${
                          matchingVariant.featured_image ? matchingVariant.featured_image.src : product.images[0].src
                        }">
                        ${value}
                      </button>`;
                  });
                  optionsHtml += `</div>`;
                }

                optionsHtml += `</div>`;
              }
            });
          }
          product.variants.forEach((variant) => {
            if (variant.available) {
              variantsSelectHtml += `<option value="${variant.id}" data-variant-id="${variant.id}" data-image-src="${variant.featured_image ? variant.featured_image.src : product.images[0].src}">${variant.options.join(" / ")}</option>`;
            }
          });
          variantsSelectHtml += `</select>`;

          const hasDiscount = product.compare_at_price && product.compare_at_price > product.price;

          let priceHtml = '';

          if (hasDiscount) {
            const discount = product.compare_at_price - product.price;
            const discountPercentage = Math.round((discount * 100) / product.compare_at_price);

            priceHtml = `
                <h5 class="product-price">${formatPrice(product.price)} <del>${formatPrice(product.compare_at_price)}</del> <span>${discountPercentage}% Off</span></h5>
            `;
          } else {
            priceHtml = `
              <div id="price">
                <h5 class="product-price">${formatPrice(product.price)}</h5>
              </div>
            `;
          }

          const firstVariant = product.variants[0];
          const isAvailable = firstVariant && firstVariant.available;
          const contentHtml = `
            <div class="left-side mx-auto">
              <div class="quick-view-gallery">
                <div class="quickview-main-slider">
                  ${product.images
                    .map(
                      (img, i) => `
                      <div>
                        <img src="${img}" data-src="${img}" class="img-fluid main-slide lazy-collection" loading="lazy" id="variant-image" alt="${product.title} ${i + 1}">
                         ${
                            offerEndDate && offerEndDate.trim() !== ""
                              ? `<div class="product-timer" id="productTimer" data-end="${offerEndDate}"></div>`
                              : ""
                          }
                      </div>`
                    )
                    .join("")}
                </div>
              </div>
            </div>
            <div class="right-side position-relative">
             <button
                type="button"
                class="close btn d-none"
                data-bs-dismiss="${toggleType === 'modal' ? 'modal' : 'offcanvas'}"
              >

                <span aria-hidden="true"><i class="ri-close-fill"></i></span>
              </button>
              <div class="right-box">
                <div class="product-right custom-scrollbar">
                  <div>
                    <div class="custom-vstar-rating-widget" product-id="${product.id}"></div>
                  </div>
                  <h3>${product.title}</h3>
                  <div class="description">${product.description}</div>${priceHtml}
                    ${optionsHtml}${variantsSelectHtml}
                    <div class="quantity-section">
                    <div class="d-flex qty-wish">
                      <div class="quantity">
                        <button class="quickview-minus btn" type="button"><i class="ri-subtract-line"></i></button>
                        <input type="number" id="product-quantity" name="quantity" value="1" min="1" max="20" class="form-control">
                        <button class="quickview-plus btn" type="button"><i class="ri-add-line"></i></button>
                      </div>
                      <a role="button" class="btn wishlist center" data-variant-id="${product.variants[0].id}" data-product-handle="${product.handle}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                          <path d="M11.5683 19.0758C11.2566 19.1858 10.7433 19.1858 10.4316 19.0758C7.77325 18.1683 1.83325 14.3825 1.83325 7.96584C1.83325 5.13334 4.11575 2.84167 6.92992 2.84167C8.59825 2.84167 10.0741 3.64834 10.9999 4.89501C11.9258 3.64834 13.4108 2.84167 15.0699 2.84167C17.8841 2.84167 20.1666 5.13334 20.1666 7.96584C20.1666 14.3825 14.2266 18.1683 11.5683 19.0758Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </a>
                       <a class="compare btn"
                            role="button"
                            data-product-handle="${product.handle}"
                            data-tooltip-add="Compare"
                            data-tooltip-remove="Remove from compare">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                              <path d="M3.28149 4.72998H15.9682C17.4899 4.72998 18.7182 5.95831 18.7182 7.47998V10.5233" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6.17816 1.83325L3.28149 4.72989L6.17816 7.62659" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18.7182 17.2699H6.03149C4.50983 17.2699 3.28149 16.0416 3.28149 14.5199V11.4766" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M15.8215 20.1666L18.7182 17.27L15.8215 14.3733" stroke="#212121" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                    </div>
                  <div class="product-buttons">
                    ${
                      isAvailable
                        ? `
                          <a href="#"
                            class="btn btn_solid cart-add"
                            data-variant-id="${firstVariant.id}"
                            data-product-handle="${product.handle}">
                            Add to Cart
                          </a>
                        `
                        : `
                          <button class="btn btn_solid soldout-btn" disabled>
                            Sold Out
                          </button>
                        `
                    }
                    <a href="/checkout" class="btn btn_solid checkout-btn" data-variant-id="${product.variants[0].id}" data-product-handle="${product.handle}">Buy Now</a>
                  </div>
                </div>
              </div>
            </div>`;

          const loader =
            toggleType === "modal"
              ? quickViewContainer.querySelector("#modalQuickViewLoader")
              : quickViewContainer.querySelector("#offcanvasQuickViewLoader");

          const content =
            toggleType === "modal"
              ? quickViewContainer.querySelector("#modalQuickViewContent")
              : quickViewContainer.querySelector("#offcanvasQuickViewContent");

          content.innerHTML = contentHtml;
          loader.classList.add("d-none");
          content.classList.remove("d-none");
          if (typeof window.updateWishlistButtonState === "function") {
            window.updateWishlistButtonState();
          }

          initProductTimer();

          const tooltipTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
          );
          tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
              boundary: document.body,
              trigger: 'hover focus'
            });
          });

          $('.quickview-main-slider').not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots:true,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="left-arrow" aria-label="Previous"><i class="ri-arrow-left-s-line"></i></button>',
            nextArrow: '<button type="button" class="right-arrow" aria-label="Next"><i class="ri-arrow-right-s-line"></i></button>',
          });


          attachDynamicEventListeners();
        }).fail(() => {
          document.getElementById("quickViewLoader").classList.add("d-none");
        });
      }
    }
  });

  function attachDynamicEventListeners() {

        document.querySelectorAll(".swatch").forEach((swatch) => {
            swatch.addEventListener("click", function () {
                const selectedImageSrc = this.getAttribute("data-image-src");
                const selectedVariantId = this.getAttribute("data-variant-id");
                document.getElementById("variant-image").src = selectedImageSrc;
                document.getElementById("hidden-variants").value = selectedVariantId;
                const addToCartButton = document.querySelector(".cart-add");
                addToCartButton.setAttribute("data-variant-id", selectedVariantId);
                document.querySelectorAll('.swatch').forEach(s => s.classList.remove("active"));
                this.classList.add("active");
            });
        });
  const selectedOptions = {};

  function updateVariant() {
    if (!product || !product.variants) return;

    const matchedVariant = product.variants.find((variant) =>
      variant.options.every((opt, i) => !selectedOptions[i] || selectedOptions[i] === opt)
    );

    if (matchedVariant) {
      const variantImage = matchedVariant.featured_image
        ? matchedVariant.featured_image.src
        : product.images[0];
      const addToCartButton = document.querySelector(".cart-add");
      const checkoutButton = document.querySelector(".checkout-btn");

      const mainSlider = $('.quickview-main-slider');
      const index = product.images.findIndex(img => img === variantImage);
      if (mainSlider.hasClass('slick-initialized')) {
        if (index >= 0) {
          mainSlider.slick('slickGoTo', index);
        }
      }
      document.getElementById("hidden-variants").value = matchedVariant.id;
      addToCartButton.setAttribute("data-variant-id", matchedVariant.id);
      checkoutButton.setAttribute("data-variant-id", matchedVariant.id);

      matchedVariant.options.forEach((optValue, i) => {
        const labelSpan = document.getElementById(`active-value-${i}`);
        if (labelSpan) labelSpan.textContent = optValue;
      });
    }
  }

  // Swatch and button click
  document.querySelectorAll(".swatch, .variant-btn").forEach((el) => {
    el.addEventListener("click", function () {
      const index = parseInt(this.getAttribute("data-index"));
      const value = this.getAttribute("data-value");
      if (selectedOptions[index] === value) return;

      selectedOptions[index] = value;

      document.querySelectorAll(`[data-index="${index}"].active`).forEach((btn) => {
        btn.classList.remove("active");
      });

      const parentGroup = document.querySelectorAll(`[data-index="${index}"]`);
      parentGroup.forEach((groupEl) => {
        groupEl.querySelectorAll(".swatch.active, .variant-btn.active").forEach((btn) => {
          btn.classList.remove("active");
        });
      });
      
      this.classList.add("active");

       const labelSpan = document.getElementById(`active-value-${index}`);
        if (labelSpan) labelSpan.textContent = value;
      updateVariant();
    });
  });

  // Quantity controls
  document.querySelector(".quickview-minus").addEventListener("click", function () {
    const quantityInput = document.getElementById("product-quantity");
    let currentValue = parseInt(quantityInput.value) || 1;
    if (currentValue > 1) quantityInput.value = currentValue - 1;
  });

  document.querySelector(".quickview-plus").addEventListener("click", function () {
    const quantityInput = document.getElementById("product-quantity");
    let currentValue = parseInt(quantityInput.value) || 1;
    quantityInput.value = currentValue + 1;
  });

  document.querySelector(".cart-add").addEventListener("click", function (e) {
    e.preventDefault();
    const variantId = this.getAttribute("data-variant-id");
    const quantity = parseInt(document.getElementById("product-quantity").value) || 1;
    addToCart(variantId, quantity);
  });

  document.querySelector(".checkout-btn").addEventListener("click", function (e) {
    e.preventDefault();
    const variantId = this.getAttribute("data-variant-id");
    const quantity = parseInt(document.getElementById("product-quantity").value) || 1;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then((response) => {
        if (response.ok) {
          location.assign("/checkout");
        } else {
          response.json().then((err) => console.error("Error:", err));
        }
      })
      .catch((error) => console.error("Error adding to cart before checkout:", error));
  });
}

  function addToCart(variantId, quantity) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then((response) => {
        if (response.ok) {
          fetchCart();
          if (cartAction === "modal") {
            new bootstrap.Modal(document.getElementById("cart-modal")).show();
            const productHandle = document.querySelector(".cart-add").getAttribute("data-product-handle");
            showProductDetails(productHandle);
          } else if (cartAction === "popup") {
            document.getElementById("cart-popup").classList.add("show");
          } else if (cartAction === "drawer") {
             const offcanvasEl = document.getElementById("cart-offcanvas");
              const offcanvas = new bootstrap.Offcanvas(offcanvasEl);

              offcanvas.show();
          }
        } else {
          response.json().then((err) => console.error("Error:", err));
        }
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }

function bindQuickViewAnimations(el, type) {
  el.addEventListener(`show.bs.${type}`, () => {
    const rightSide = el.querySelector(".right-side");
    if (rightSide) rightSide.classList.add("d-none");
  });

  el.addEventListener(`shown.bs.${type}`, () => {
    const content = el.querySelector(".modal-content, .offcanvas-body");
    const rightSide = el.querySelector(".right-side");

    requestAnimationFrame(() => {
      if (content) content.classList.add("open");
    });

    setTimeout(() => {
      if (rightSide) rightSide.classList.remove("d-none");
    }, 400);
  });

  el.addEventListener(`hidden.bs.${type}`, () => {
    document.body.style.overflow = "auto";

    document
      .querySelectorAll(`.${type}-backdrop`)
      .forEach(b => b.remove());
  });
}

const offcanvasEl = document.getElementById("quick-view-offcanvas");

if (offcanvasEl) bindQuickViewAnimations(offcanvasEl, "offcanvas");


const quickViewModal = document.getElementById("quick-view");

if (quickViewModal) {
  quickViewModal.addEventListener("show.bs.modal", () => {
    const content = quickViewModal.querySelector(".modal-content");
    const leftSide = quickViewModal.querySelector(".left-side");
    const rightSide = quickViewModal.querySelector(".right-side");

    if (content) content.classList.remove("open");
    if (rightSide) rightSide.classList.add("d-none");
  });

  quickViewModal.addEventListener("shown.bs.modal", () => {
    const content = quickViewModal.querySelector(".modal-content");
    const leftSide = quickViewModal.querySelector(".left-side");
    const rightSide = quickViewModal.querySelector(".right-side");

    requestAnimationFrame(() => {
      if (content) content.classList.add("open");
    });

    setTimeout(() => {
      if (rightSide) rightSide.classList.remove("d-none");
    }, 500);
  });
  quickViewModal.addEventListener("hidden.bs.modal", () => {
    const content = quickViewModal.querySelector(".modal-content");
    const rightSide = quickViewModal.querySelector(".right-side");

    if (content) content.classList.remove("open");
    if (rightSide) rightSide.classList.add("d-none");

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "auto";     // 🔥 KEY FIX
    document.body.style.paddingRight = "0px";

    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((bd) => bd.remove());
    }, 150);
  });
}

function initProductTimer() {
  document.querySelectorAll(".product-timer").forEach(function (timerEl) {
    const endTimeStr = timerEl.dataset.end;
    if (!endTimeStr) return;

    const endTime = new Date(endTimeStr).getTime();

    function updateTimer() {
      const now = Date.now();
      const distance = endTime - now;

      if (distance <= 0) {
        timerEl.textContent = "Expired";
        clearInterval(timerInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timerEl.textContent = `${days} D : ${hours} H : ${minutes} M : ${seconds} S`;
    }

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer();
  });
}

document.addEventListener(
  "click",
  function (e) {
    const closeBtn = e.target.closest("#quick-view-offcanvas .btn-close");
    if (!closeBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const offcanvasEl = document.getElementById("quick-view-offcanvas");
    if (!offcanvasEl) return;
    const instance =
      bootstrap.Offcanvas.getInstance(offcanvasEl) ||
      new bootstrap.Offcanvas(offcanvasEl);

    instance.hide();
  },
  true
);

});



